// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLaserEmissionTriangleYellow_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M30.2488 5.17397C31.0094 3.79551 32.9906 3.79551 33.7512 5.17397L62.3635 57.0338C63.0989 58.3668 62.1347 60 60.6123 60H3.38765C1.86528 60 0.901074 58.3668 1.6365 57.0338L30.2488 5.17397Z" fill="#FDCA40"/>
  <path d="M32 7.59603L58.8193 57L5.1807 57L32 7.59603Z" fill="#FDCA40" stroke="#1A2329" stroke-width="2"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M31 55V46.1579L29.1864 50.6467L27.332 49.8975L29.2413 45.1717L22.8065 51.6066L21.3923 50.1924L27.8915 43.6932L23.0623 45.5954L22.3293 43.7346L26.7328 42H18V40H26.7376L22.3334 38.2651L23.0664 36.4043L27.8916 38.305L21.3944 31.8078L22.8086 30.3936L29.2328 36.8178L27.3276 32.1023L29.182 31.3531L31 35.8528V25H33V35.8687L34.8242 31.3538L36.6785 32.103L34.7782 36.8064L41.1913 30.3934L42.6055 31.8076L36.1048 38.3083L40.9377 36.4046L41.6707 38.2654L37.2672 40H49.5V42H37.2719L41.6748 43.7343L40.9418 45.5952L36.1049 43.6899L42.6076 50.1925L41.1934 51.6068L34.7697 45.1831L36.6741 49.8968L34.8198 50.646L33 46.1419V55H31Z" fill="#1A2329"/>
</svg>
`;
/**
 * IconMedLaserEmissionTriangleYellow is a generated icon component.
 */
let IconMedLaserEmissionTriangleYellow = IconMedLaserEmissionTriangleYellow_1 = class IconMedLaserEmissionTriangleYellow extends IconBaseElement {
    render() {
        return html `${IconMedLaserEmissionTriangleYellow_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLaserEmissionTriangleYellow.icons = new Map([
    ['s8', _s64IconSvg],
    ['s12', _s64IconSvg],
    ['s16', _s64IconSvg],
    ['s24', _s64IconSvg],
    ['s32', _s64IconSvg],
    ['s40', _s64IconSvg],
    ['s48', _s64IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconMedLaserEmissionTriangleYellow = IconMedLaserEmissionTriangleYellow_1 = __decorate([
    customElement('zui-icon-med-laser-emission-triangle-yellow')
], IconMedLaserEmissionTriangleYellow);
export { IconMedLaserEmissionTriangleYellow };
